import LanguageNames from 'ui-addon-i18n/constants/LanguageNames';
import { supportedPublicLanguages } from 'academy-common-lib/constants/academySupportedLanguages';
import { List } from 'foundations-components/transitional/components/List';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { ThemedDropdown } from '../../../components/ThemedComponents';
import { Link } from 'foundations-components/transitional/components/Link';
import { useMemo } from 'react';
import { getPublicLang } from 'academy-common-lib/utils/url';
import { getLanguageUrl } from '../../../utils/urls';
import { getAvailableLanguages } from '../../../utils/linkedLanguages';
import { LanguageIcon } from 'foundations-assets/icons/components/LanguageIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PublicLanguageDropdown = ({
  options = supportedPublicLanguages,
  href = window.location.href,
  languageLinkedContent,
  contentType,
  pagePath
}) => {
  const appLanguage = getPublicLang();
  const availableLanguages = getAvailableLanguages({
    languageLinkedContent,
    legacyLanguages: options,
    currentLanguage: appLanguage
  });
  const sortedLanguages = useMemo(() => [...availableLanguages].sort(), [availableLanguages]);
  return /*#__PURE__*/_jsxs(TFlex, {
    align: "center",
    children: [/*#__PURE__*/_jsx(IconHolder, {
      color: "icon-core-subtle",
      icon: LanguageIcon,
      marginInlineStart: "-200",
      padding: "0",
      size: "600"
    }), /*#__PURE__*/_jsx(ThemedDropdown, {
      buttonText: LanguageNames[appLanguage],
      buttonUse: "transparent",
      paddingInline: "300",
      children: /*#__PURE__*/_jsx(List, {
        wrapChildren: true,
        children: sortedLanguages.map(language => /*#__PURE__*/_jsx(Link, {
          href: getLanguageUrl({
            language,
            contentType,
            pagePath,
            languageLinkedContent,
            href
          }),
          children: LanguageNames[language]
        }, language))
      })
    })]
  });
};
export default PublicLanguageDropdown;